import { generatedTypesNew } from '@css-xp/graphtypes';

export const COLLECTION_ENTITLEMENT_TYPE = 'COLLECTION';

export const appsFilter = {
  relatesFromEntitlementsRelationshipType: generatedTypesNew.RelationshipPathType.APP_DEPENDENCE,
};

export const addOnsFilter = {
  relatesFromEntitlementsRelationshipType: 'ADDON_DEPENDENCE',
};

export const sandboxFilter = {
  relatesFromEntitlementsRelationshipType: generatedTypesNew.RelationshipPathType.SANDBOX_DEPENDENCE,
};

export const collectionFilter = {
  relatesFromEntitlementsRelationshipType: COLLECTION_ENTITLEMENT_TYPE,
};

export const enterpriseFilter = {
  relatesFromEntitlementsRelationshipType: 'ENTERPRISE',
};

export const SORT_KEYS = {
  CLOUD_SITE: 'cloudSiteHostname',
  RENEW_DATE: 'lastPeriodEndDate',
  CREATED_DATE: 'createdDate',
  ID: 'id',
  PLAN: 'edition',
};

export const COLUMNS = {
  SUBSCRIPTION: 'Subscription',
  STATUS: 'Status',
  APPS: 'Apps',
  OFFERING: 'Plan',
  ORGANIZATION_NAME: 'Organization name',
  SITE: 'Site',
  COMPANY: 'Company',
  SOLD_TO_ADDRESS: 'Sold-to address',
  CUSTOMER_CONTACTS: 'Customer contacts',
  BILLED_USERS: 'Billed users/user tier',
  RENEW_ON: 'Renew date',
  BILLING_CYCLE: 'Billing cycle',
  ENTITLEMENT_NUMBER: 'Entitlement number',
  LAST_INVOICE_AMOUNT: 'Last invoice amount',
  CREATED: 'Created',
  ID: 'Entitlement Id',
  CUSTOMER: 'Customer',
  BILLING_PROFILE: 'Billing profile',
  USAGE: 'Quantity',
  ADD_ONS: 'Add-ons',
  RENEW_IN: 'Renew in',
  INCLUDED_PRODUCTS: 'Included products',
};

export enum TAB_ENUM {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  FREE = 'Free',
  UPCOMING = 'Upcoming',
}

export const TAB_SPECIFIC_COLUMNS = {
  [TAB_ENUM.ACTIVE]: {
    [COLUMNS.SUBSCRIPTION]: COLUMNS.SUBSCRIPTION,
    [COLUMNS.STATUS]: COLUMNS.STATUS,
    [COLUMNS.APPS]: COLUMNS.APPS,
    [COLUMNS.ADD_ONS]: COLUMNS.ADD_ONS,
    [COLUMNS.INCLUDED_PRODUCTS]: COLUMNS.INCLUDED_PRODUCTS,
    [COLUMNS.OFFERING]: COLUMNS.OFFERING,
    [COLUMNS.ORGANIZATION_NAME]: COLUMNS.ORGANIZATION_NAME,
    [COLUMNS.SITE]: COLUMNS.SITE,
    [COLUMNS.SOLD_TO_ADDRESS]: COLUMNS.SOLD_TO_ADDRESS,
    [COLUMNS.CUSTOMER_CONTACTS]: COLUMNS.CUSTOMER_CONTACTS,
    [COLUMNS.BILLED_USERS]: COLUMNS.BILLED_USERS,
    [COLUMNS.RENEW_ON]: COLUMNS.RENEW_ON,
    [COLUMNS.BILLING_CYCLE]: COLUMNS.BILLING_CYCLE,
    [COLUMNS.ENTITLEMENT_NUMBER]: COLUMNS.ENTITLEMENT_NUMBER,
    [COLUMNS.CREATED]: COLUMNS.CREATED,
    [COLUMNS.LAST_INVOICE_AMOUNT]: COLUMNS.LAST_INVOICE_AMOUNT,
    [COLUMNS.COMPANY]: COLUMNS.COMPANY,
  },
  [TAB_ENUM.INACTIVE]: {
    [COLUMNS.SUBSCRIPTION]: COLUMNS.SUBSCRIPTION,
    [COLUMNS.STATUS]: COLUMNS.STATUS,
    [COLUMNS.APPS]: COLUMNS.APPS,
    [COLUMNS.ADD_ONS]: COLUMNS.ADD_ONS,
    [COLUMNS.INCLUDED_PRODUCTS]: COLUMNS.INCLUDED_PRODUCTS,
    [COLUMNS.OFFERING]: COLUMNS.OFFERING,
    [COLUMNS.ORGANIZATION_NAME]: COLUMNS.ORGANIZATION_NAME,
    [COLUMNS.SITE]: COLUMNS.SITE,
    [COLUMNS.SOLD_TO_ADDRESS]: COLUMNS.SOLD_TO_ADDRESS,
    [COLUMNS.CUSTOMER_CONTACTS]: COLUMNS.CUSTOMER_CONTACTS,
    [COLUMNS.ENTITLEMENT_NUMBER]: COLUMNS.ENTITLEMENT_NUMBER,
    [COLUMNS.CREATED]: COLUMNS.CREATED,
    [COLUMNS.COMPANY]: COLUMNS.COMPANY,
  },
  [TAB_ENUM.FREE]: {
    [COLUMNS.SUBSCRIPTION]: COLUMNS.SUBSCRIPTION,
    [COLUMNS.STATUS]: COLUMNS.STATUS,
    [COLUMNS.APPS]: COLUMNS.APPS,
    [COLUMNS.ADD_ONS]: COLUMNS.ADD_ONS,
    [COLUMNS.INCLUDED_PRODUCTS]: COLUMNS.INCLUDED_PRODUCTS,
    [COLUMNS.OFFERING]: COLUMNS.OFFERING,
    [COLUMNS.ORGANIZATION_NAME]: COLUMNS.ORGANIZATION_NAME,
    [COLUMNS.SITE]: COLUMNS.SITE,
    [COLUMNS.CUSTOMER_CONTACTS]: COLUMNS.CUSTOMER_CONTACTS,
    [COLUMNS.BILLED_USERS]: COLUMNS.BILLED_USERS,
    [COLUMNS.BILLING_CYCLE]: COLUMNS.BILLING_CYCLE,
    [COLUMNS.ENTITLEMENT_NUMBER]: COLUMNS.ENTITLEMENT_NUMBER,
    [COLUMNS.CREATED]: COLUMNS.CREATED,
  },
  [TAB_ENUM.UPCOMING]: {
    [COLUMNS.SUBSCRIPTION]: COLUMNS.SUBSCRIPTION,
    [COLUMNS.STATUS]: COLUMNS.STATUS,
    [COLUMNS.APPS]: COLUMNS.APPS,
    [COLUMNS.ADD_ONS]: COLUMNS.ADD_ONS,
    [COLUMNS.INCLUDED_PRODUCTS]: COLUMNS.INCLUDED_PRODUCTS,
    [COLUMNS.OFFERING]: COLUMNS.OFFERING,
    [COLUMNS.ORGANIZATION_NAME]: COLUMNS.ORGANIZATION_NAME,
    [COLUMNS.SITE]: COLUMNS.SITE,
    [COLUMNS.SOLD_TO_ADDRESS]: COLUMNS.SOLD_TO_ADDRESS,
    [COLUMNS.CUSTOMER_CONTACTS]: COLUMNS.CUSTOMER_CONTACTS,
    [COLUMNS.ENTITLEMENT_NUMBER]: COLUMNS.ENTITLEMENT_NUMBER,
    [COLUMNS.CREATED]: COLUMNS.CREATED,
    [COLUMNS.COMPANY]: COLUMNS.COMPANY,
  },
};

export const BILLED_ELSEWHERE_PRODUCT_IDS = [
  'opsgenie',
  'OPSGENIE',
  'Opsgenie',
  'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
];

/**
 * pricingType Free and Limited Free are considered as free products.
 * pricingType Free is for subscription with Plan `Free` and `Beta`.
 * pricingType Limited Free is for subscription with Plan `Free Standard`.
 */
export const FREE_PRICING_TYPES = [generatedTypesNew.PricingType.FREE, generatedTypesNew.PricingType.LIMITED_FREE];

export enum SUBSCRIPTION_PAGE_SIDEBAR {
  INCLUDED_PRODUCTS = 'included-products',
}

export enum ENTITY_INVALID_REASON {
  HAMS_ENTITY = 'HAMS_ENTITY',
  ANNUAL_ENTITY = 'ANNUAL_ENTITY',
  SAME_TXA = 'SAME_TXA',
  INACTIVE_BILLING_STATUS = 'INACTIVE_BILLING_STATUS',
  ADD_ON_ENTITY = 'ADD_ON_ENTITY',
  APP_ENTITY = 'APP_ENTITY',
}

export const SubscriptionRelationshipType = {
  ...generatedTypesNew.RelationshipPathType,
  ADDON_DEPENDENCE: 'ADDON_DEPENDENCE',
};
